import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';

const firebaseConfig = {
  apiKey: "AIzaSyDmwPQMWtu9CtrySjlYeQheiIeoLuUknNM",
  authDomain: "lithlan.firebaseapp.com",
  projectId: "lithlan",
  storageBucket: "lithlan.firebasestorage.app",
  messagingSenderId: "105732798823",
  appId: "1:105732798823:web:a4c82625dedbffa65457c2",
  measurementId: "G-V8DSCRSX53"
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app);
export default app;